import HistoryChanges from './HistoryChanges';
import Loader from './Loader';

const History = ({items}) => {
    return (
        <table className="small-table history-table">
            <tbody>
            {items.length === 0 && (
                <tr>
                    <td colSpan={3}>
                        <Loader/>
                    </td>
                </tr>
            )}
            {items.length > 0 && items.map((item, idx) => (
                <tr key={idx}>
                    <td>{item.userName}</td>
                    <td>
                        <ul>
                            {HistoryChanges(item.changes)}
                        </ul>
                    </td>
                    <td className="time">{item.humanizedDate}</td>
                </tr>
            ))}
            </tbody>
        </table>
    )
}

export default History;